import { AnySchema } from 'ajv';

import { FieldErrorMessage } from '../../../../models/FieldErrorMessage';
import { contractFormSchema } from '../../../../styledComponents/Forms/SelectContractForm/selectContractForm.validation';
import { subscriptionOptionsSchema } from '../../../../styledComponents/Forms/SubscriptionOptions/subscriptionOptions.validation';
import { subscriptionSummarySchema } from '../../../../styledComponents/FormSummary/SubscriptionSummary/subscriptionSummary.validation';
import { validateFormData } from '../../../../utils/validations/validateFormData';
import { subscriptionPricingSchema } from '../../../../styledComponents/RenewSubscriptionFormPage/FormSections/Common/SubscriptionRenewPricing/subscriptionPricing.validation';
import { tlRenewSubscriptionDetailsSchema } from '../../../../styledComponents/RenewSubscriptionFormPage/FormSections/TravelLicenseRenewSubscription/TLRenewSubscriptionDetails/tlRenewSubscriptionDetails.validation';
import { RenewTLSubscriptionModel } from '../../../../models/types/TravelLicense/RenewTLSubscriptionModel';

const schema: AnySchema | any = {
  type: 'object',
  properties: {
    ...tlRenewSubscriptionDetailsSchema.properties,
    ...subscriptionOptionsSchema.properties,
    ...subscriptionSummarySchema.properties,
    ...subscriptionPricingSchema.properties,
  },
  dependencies: {
    ...subscriptionOptionsSchema.dependencies,
    ...subscriptionSummarySchema.dependencies,
  },
  required: [
    ...contractFormSchema.required,
    ...tlRenewSubscriptionDetailsSchema.required,
    ...subscriptionOptionsSchema.required,
    ...subscriptionSummarySchema.required,
    ...subscriptionPricingSchema.required,
  ],
};

export const validateKERenewSubscriptionForm = (
  data: RenewTLSubscriptionModel,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, schema);
